import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DefaultSelectV2 from '../DefaultSelectV2';
import MultiSelectV2 from '../MultiSelectV2';
import { TIPO_EQUIPAMENTO_NOME } from '../../../helpers/equipamentoModelos';

const TIPO_OPTIONS = Object.entries(TIPO_EQUIPAMENTO_NOME).map(([id, descricao]) => ({
  id,
  descricao,
}));

const TIPO_MULTI_OPTIONS = TIPO_OPTIONS.map((option) => ({
  value: option.id,
  label: option.descricao,
}));

const TipoEquipamentoSelectV2 = ({
  error,
  onChange,
  value,
  disabled,
  isRequired,
  showEmpty,
  multiSelect,
  limitTags,
}) => {
  const selectedIds = useMemo(() => {
    if (Array.isArray(value)) return value;
    return value ? [value] : [];
  }, [value]);

  if (multiSelect) {
    return (
      <MultiSelectV2
        label="Tipo Equipamento"
        disabled={disabled}
        error={error}
        isRequired={isRequired}
        options={TIPO_MULTI_OPTIONS}
        limitTags={limitTags}
        defaultValue={TIPO_MULTI_OPTIONS.filter((option) => selectedIds.indexOf(option.value) > -1)}
        onChange={(values) => onChange(values && values.length ? values.map((item) => item.value) : null)}
      />
    );
  }

  return (
    <DefaultSelectV2
      error={error}
      showEmpty={showEmpty}
      isRequired={isRequired}
      label="Tipo Equipamento"
      name="tipoEquipamento"
      onSelect={(e) => onChange(e.target.value ? e.target.value : null)}
      options={TIPO_OPTIONS}
      value={value}
      handlerOption={(option) => option.descricao}
      disabled={disabled}
    />
  );
};

TipoEquipamentoSelectV2.propTypes = {
  error: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  isRequired: PropTypes.any,
  showEmpty: PropTypes.bool,
  multiSelect: PropTypes.bool,
  limitTags: PropTypes.number,
};

TipoEquipamentoSelectV2.defaultProps = {
  value: '',
  showEmpty: false,
  onChange: () => {},
  multiSelect: false,
  limitTags: 2,
};

export default TipoEquipamentoSelectV2;
